// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cancel-public-beta-notice-cancel-public-beta-notice-8c9f8{align-items:center;display:flex}.cancel-public-beta-notice-cancel-public-beta-notice-8c9f8 .cancel-public-beta-notice-link-098c3{font-size:12px;margin:0 4px}.cancel-public-beta-notice-cancel-public-beta-notice-8c9f8 .cancel-public-beta-notice-close-icon-74a2b{cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cancel-public-beta-notice": "cancel-public-beta-notice-cancel-public-beta-notice-8c9f8",
	"cancelPublicBetaNotice": "cancel-public-beta-notice-cancel-public-beta-notice-8c9f8",
	"link": "cancel-public-beta-notice-link-098c3",
	"close-icon": "cancel-public-beta-notice-close-icon-74a2b",
	"closeIcon": "cancel-public-beta-notice-close-icon-74a2b"
};
export default ___CSS_LOADER_EXPORT___;
